import template from './field-type-dropdown.jade';

export default angular
    .module('cian.addForm.fieldTypeDropdown', [])
    .directive('cianAfHelperFieldTypeDropdown', () => ({
        bindToController: {
            textName: '@',
            inputName: '@',
            inputTitle: '@?',
            inputModel: '=',
            inputModelName: '@',
            items: '=',
            defaultValue: '=?',
            // значение при выборе которого должно отображаться сообщение
            showMessageValue: '=?',
            // сообщение
            customMessage: '=?',
        },
        controller: function ($scope) {
            'ngInject';

            if (this.customMessage) {
                this.isShowCustomMessage = false;

                $scope.$watch(() => this.inputModel, (viewValue) => {
                  this.isShowCustomMessage = viewValue === this.defaultValue;
                });
            }
        },
        template,
        controllerAs: 'field'
    }))
    .name;
